import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ChangeListener } from './changeListener';
import { ViewContextDto } from '@savvy/view-composite';
import { EventBusService } from './EventBusService';
import { SectionHeaderDefinitionDto } from '@savvy/view-definition';
import { ContextIdDto } from '@savvy/quickbooks';

@Component({
    selector: 'app-section-header',
    templateUrl: 'sectionHeader.component.html'
})
export class SectionHeaderComponent {

    @Input() sectionHeaderDefinitionDto: SectionHeaderDefinitionDto;
    @Input() contextIdDto: ContextIdDto;
    @Input() viewContext: ViewContextDto;
    @Input() form: UntypedFormGroup;
    @Input() eventBus: EventBusService;
    @Input() additionalDataMapDto: any;
    @Input() showPlaceholder: boolean;
    @Input() changeListener: ChangeListener;
}

